/* eslint max-len: ["error", { "code": 140 }] */
import React from 'react';
import Image, { getVariantUrls } from '@fenderdigital/react-ui-kit/image';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  label: {
    id: 'tunerFeatureScreens.label',
    defaultMessage: '{label}',
  },
  fenderTuneiPhone: {
    id: 'tunerFeatureScreens.fenderTuneiPhone',
    defaultMessage: 'Fender Tune for iPhone:',
  },
  nowPlayerPack: {
    id: 'tunerFeatureScreens.nowPlayerPack',
    defaultMessage: 'Now with Player Pack',
  },
  essentialTools: {
    id: 'tunerFeatureScreens.essentialTools',
    defaultMessage: 'Essential tools for every player',
  },
});

interface TunerFeatureScreen {
  label: string;
  'image-url': string;
}

interface TunerFeatureScreensProps {
  list?: TunerFeatureScreen[];
}

const TunerFeatureScreens: React.FC<TunerFeatureScreensProps> = ({ list }) => (
  <div className="tuner-feature-screens" data-id="tuner-feature-screens">
    <h4 className="ma0 mb1 pa0 futura-heavy f5 tc tl-ns lh-title">
      <FormattedMessage {...messages.fenderTuneiPhone} />
      <span className="pl1-ns red db di-ns">
        <FormattedMessage {...messages.nowPlayerPack} />
      </span>
    </h4>
    <p className="mb4 mb3-ns tc tl-ns f6">
      <FormattedMessage {...messages.essentialTools} />
    </p>
    <ul className="list pl0 ma0 mw6 center mh0-ns mw7-ns flex flex-wrap mb4 justify-center justify-start-ns">
      {list?.map(
        (listItem): JSX.Element => (
          <li className="w4 mb4 mh2 mr3-ns ml0-ns" key={`tuner-feature-screens-${listItem.label}`}>
            <p className="f6 f5-ns ma0 mb2 futura-heavy">
              <FormattedMessage {...messages.label} values={{ label: listItem.label }} />
            </p>
            <div className="br3 overflow-hidden ba b--light-gray">
              <Image images={getVariantUrls(listItem['image-url'], null)} ratio={1} />
            </div>
          </li>
        ),
      )}
    </ul>
  </div>
);

export default TunerFeatureScreens;
